import React from 'react';
import ReactDOM from 'react-dom';

class SMCalendarBaloonBaseView extends React.Component {
  
  constructor(props) {
    super(props);
    this.baloonBeforeHeight = 15;
  }
  
  baloonBaseSetting(baloonWidth, baloonHeight) {
    return({
      style: {
        visibility: 'hidden',
        bottom: $(window).height() - this.props.clientY + this.baloonBeforeHeight,
        left: this.props.clientX - baloonWidth / 2,
      },
      before: {
        style: {
          left: 50,
        },
      }
    });
  }
  
  componentDidMount() {
    let baloonSetting = this.initializeBaloonSetting();
    
    $(".js-datepicker").datepicker({dateFormat:"yymmdd", onClose:function(e){}});
    
    $(document).on('click', (e)=>{
      if ($(e.target).closest('.js-calendar-baloon').length > 0 ||
          $(e.target).closest('#ui-datepicker-div').length > 0 ||
          $(e.target).hasClass('ui-datepicker-next') ||
          $(e.target).hasClass('ui-datepicker-prev')) {
        return;
      } else {
        this.unmount();
      }
    });
  }
  
  // 全てのイベントが死んじゃう
  componentWillUnmount() {
    document.getElementsByTagName('head')[0].removeChild(document.getElementById('js-baloon-before'));
    $(document).off('click');
  }
  
  unmount() {
    ReactDOM.unmountComponentAtNode(document.getElementById('js-baloon-container'));
  }
  
  // handleClickSaveButton(e) {
  // },
  
  // handleClickDeleteButton(e) {
  // },
  
  isBaloonOutOfTopEdge(baloonHeight) {
    return baloonHeight > this.props.clientY;
  }
  
  isBaloonOutOfRightEdge(baloonWidth) {
    return $(window).width() < this.props.clientX + baloonWidth / 2; 
  }
  
  isBaloonOutOfLeftEdge(baloonWidth) {
    return this.props.clientX - baloonWidth / 2 < 0;
  }
  
  initializeBaloonSetting() {
    let baloonBeforeClassName = 'baloon-bottom',
        baloonWidth = $('.js-calendar-baloon').width(),
        baloonHeight = $('.js-calendar-baloon').height(),
        baloonSetting = this.baloonBaseSetting(baloonWidth, baloonHeight);
        
    
    
    if (this.isBaloonOutOfTopEdge(baloonHeight)) {
      baloonBeforeClassName = 'baloon-top';
      baloonSetting.style.bottom = $(window).height() - baloonHeight - this.baloonBeforeHeight - this.props.clientY;
    }
    if (this.isBaloonOutOfRightEdge(baloonWidth)) {
      baloonSetting.style.left = $(window).width() - baloonWidth;
      baloonSetting.before.style.left = Math.round(((this.props.clientX - ($(window).width() - baloonWidth))) / baloonWidth * 100);
    } else if (this.isBaloonOutOfLeftEdge(baloonWidth)) {
      baloonSetting.style.left = 0;
      baloonSetting.before.style.left = Math.round((this.props.clientX / baloonWidth) * 100);
    }
    
    let css = '.'+baloonBeforeClassName+':before{left:'+baloonSetting.before.style.left+'%}';
    let style = document.createElement('style');
    style.id = 'js-baloon-before';
    style.appendChild(document.createTextNode(css));
    document.getElementsByTagName('head')[0].appendChild(style);
    $('.js-calendar-baloon').addClass(baloonBeforeClassName)
                            .css(baloonSetting.style)
                            .css('visibility', 'visible');
    
    return baloonSetting;
  }
}
export default SMCalendarBaloonBaseView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/calendar/SMCalendarBaloonBaseView.jsx